import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();
export default class ProtocolAPI {

    URI_V1 = "/v1/protocols"

    createMultipart = async (formData: any) => {
        return await apiService.postFormData(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`, formData);
    };

    updateMultipart = async (id: any, formData: any) => {
        return await apiService.putFormData(`${this.URI_V1}/${id}`, formData);
    };


    findAll = async () => {
        return await apiService.get(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    delete = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}`);
    };

}
